import clsx from 'clsx';

import { Link } from '@northladder/i18n';

import { InstagramIcon, LinkedInIcon, XTwitterIcon } from './icons';

export const socialMediaProfiles = [
  {
    title: 'LinkedIn',
    href: 'https://www.linkedin.com/company/northladder',
    icon: LinkedInIcon,
  },
  {
    title: 'Instagram',
    href: 'https://instagram.com/northladder',
    icon: InstagramIcon,
  },
  {
    title: 'X / Twitter',
    href: 'https://x.com/northladder',
    icon: XTwitterIcon,
  },
];

/**
 * Properties for the SocialMedia component.
 */
interface ISocialMediaProps {
  /** Optional CSS class name for the list. */
  className?: string;
  /** Whether to use white text for dark backgrounds. */
  isInverted?: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * This renders a list of social media profiles that can be used in the footer.
 */
export function SocialMedia({
  className,
  isInverted = false,
}: ISocialMediaProps) {
  return (
    <ul
      className={clsx(
        'flex gap-x-10',
        isInverted ? 'text-white' : 'text-gray-950',
        className
      )}
    >
      {socialMediaProfiles.map((socialMediaProfile) => (
        <li key={socialMediaProfile.title}>
          <Link
            aria-label={socialMediaProfile.title}
            className={clsx(
              'transition'
              // isInverted ? 'hover:text-primary-200' : 'hover:text-primary-700'
            )}
            href={socialMediaProfile.href}
            target="_blank"
          >
            <socialMediaProfile.icon className="h-6 w-6 fill-current" />
          </Link>
        </li>
      ))}
    </ul>
  );
}
